export default {
    name: "TTF DA / FM",
    data:
    {
        "id": "545c2cfd-0a08-4eaf-9421-aff402aacdee",
        "title": "TTF DA/FM @17",
        "type": "Composite",
        "config": {
            "operator": "Subtract",
            "combine_on": "date",
            "left": {
                "id": "140c6b14-dac2-4d3b-ad95-f40e19b16e23",
                "type": "Single",
                "config": {
                    "type_id": "vwap",
                    "hub_id": 14,
                    "product_id": 1,
                    "hour": "17",
                    "start_date": "2025-06-26",
                    "end_date": "2025-08-25"
                }
            },
            "right": {
                "id": "18597468-94a5-4cde-beb8-a386acc1e6d9",
                "type": "Single",
                "config": {
                    "type_id": "vwap",
                    "hub_id": 14,
                    "product_id": "999",
                    "hour": "17",
                    "start_date": "2025-06-26",
                    "end_date": "2025-08-25"
                }
            }
        }
    }

}